"use client";

import CreateOrEditGift from "@/components/core/gift/create-update-gift";
import { useSearchParams } from "next/navigation";

const CreateGiftContent = ({ lang }: { lang: string }) => {
  const searchParams = useSearchParams();
  const presetProduct = searchParams.get("product");
  const presetproperties = searchParams.get("option");
  const presetQuantity = Number(searchParams.get("quantity"));
  return (
    <CreateOrEditGift
      lang={lang}
      gift={""}
      presetProduct={presetProduct}
      presetQuantity={presetQuantity}
      presetproperties={presetproperties}
    />
  );
};

export default CreateGiftContent;
